var easeInOut = function (t) {
    return 1 - (Math.cos(Math.PI * t) + 1) / 2;
};
export { easeInOut };
